export const RESET = 'taskSearch/RESET';
export const SET_TASKS = 'taskSearch/SET_TASKS';
export const APPEND_TASKS = 'taskSearch/APPEND_TASKS';
export const SELECT = 'taskSearch/SELECT';
export const UNSELECT = 'taskSearch/UNSELECT';
export const CHANGE_SORT = 'taskSearch/CHANGE_SORT';
export const SAVE_LAST_SUBMITTED_FORMDATA = 'taskSearch/SAVE_LAST_SUBMITTED_FORMDATA';
